<template>
  <component id="app" :style="style" :is="wrapperComponent">
    <sameday-header @close="$emit('close', $event)" />
    <sameday-controller
      :search="search"
      @scroll-to="$emit('scroll-to', $event)"
      @onnextstep="$emit('onnextstep', $event)"
      @onbookerror="$emit('onbookerror', $event)"
      @on:ocr_scan="$emit('on:ocr_scan', $event)"
      @on:submitted="$emit('on:submitted', $event)"
      @on:book_success="$emit('on:book_success', $event)"
    ></sameday-controller>
  </component>
</template>

<script>
import SamedayHeader from "@/components/AppSamedayHeader.vue";
import SamedayController from "@/components/Sameday/SamedayController.vue";
import AppWrapperDefault from "@/components/Layout/WrapperDefault.vue";
import AppWrapperModal from "@/components/Layout/WrapperModal.vue";

export default {
  components: {
    SamedayHeader,
    SamedayController,
    AppWrapperDefault,
    AppWrapperModal,
  },
  props: {
    search: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    style() {
      return {
        "--bg-color":
          this.$store.state.config?.colors?.bodyBackground || "#F3F4F6",
      };
    },
    wrapperComponent() {
      return this.$store.state?.config?.modalMode
        ? "app-wrapper-modal"
        : "app-wrapper-default";
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: var(--bg-color);
}
</style>
